import React from "react"
import Layout from "../components/layout"
import { graphql } from "gatsby"
import SubHeader from "../components/SubHeader"
import SubHero from "../components/SubHero"
import { FaChild } from "@react-icons/all-files/fa/FaChild"
import ContactForm from "../components/ContactForm"
import { Link } from "gatsby"
import {IoMdArrowRoundBack} from "react-icons/io";
import { navigate } from "gatsby";
import SEO from "../components/seo"



export default function ProductDetailis({ data }) {
  const { productName, productFeatures } = data.contentfulProductInfo
  const desc = data.contentfulProductInfo.description.description
  const ImgFluid = data.contentfulProductInfo.productLogo.fluid
  const sliderImages = data.contentfulProductInfo.productImage
  const videoLink = data.contentfulProductInfo.videoLink;

  /*   const featureList = productFeatures.map((feature, index) => {
    return <Card key={index}>{feature}</Card>
  })
 */
  const featureList = []

  const createFature = productFeatures.map(feature =>
    featureList.push({
      heading: feature,
    })
  )

  return (
    <div>
    <SEO title={"Sipariş Makinesi - " + productName} keywords={[`sipariş makinesi`, `adelsoft`, `paket servis sistemi`,`müşteri tanıma sistemi`, `yemek sepeti otomatik çıkartma`,`getir otomatik çıkartma`,`sipariş otomatik onaylama`]} />
    
      <Layout>
      <button onClick={() => navigate(-1)}> <IoMdArrowRoundBack /> Önceki Sayfa </button>
        <SubHeader
          heading={productName}
          text={desc}
          buttons={
            <a variant="button.secondary.lg" href="#" mt="6">
              Görüşme Talebinde Bulun
              <FaChild />
            </a>
          }
        />
  
        <SubHero
          subheading="Subheading"
          heading="Sağladığı Avantajlar"
          text="Lütfen tüm avantajları dikkatli bir şekilde inceleyiniz..."
          features={featureList}
          videos={videoLink}
          image={ImgFluid}
          sliderimage={sliderImages}
        />

        <ContactForm />
      </Layout>
    </div>
  )
}

export const query = graphql`
  query MyQuery($slug: String) {
    contentfulProductInfo(slug: { eq: $slug }) {
      productName
      productLogo {
        fluid {
          ...GatsbyContentfulFluid
        }
      }
      productImage {
        fluid(maxWidth: 800, maxHeight: 600) {
          ...GatsbyContentfulFluid
        }
      }
      videoLink
      productFeatures
      description {
        description
      }
      slug
    }
  }
`
